import React, { useMemo, useState } from "react";
import Select, { SelectProps, transformDataToSelectOption } from "@/components/atoms/Select";
import { useGetCompanyTypes } from "@/services/RegisterCompany";
import { useTranslation } from "react-i18next";

interface SelectCompanyTypeProps extends SelectProps {
  showAdminOption: boolean;
}

const SelectCompanyType: React.FC<SelectCompanyTypeProps> = ({ showAdminOption = false, ...restProps }) => {
  const [filteredOptions, setFilteredOptions] = useState<string[]>([]);
  const { data: companyTypeOptions, isLoading } = useGetCompanyTypes();
  const { t } = useTranslation();

  useMemo(() => {
    if (!showAdminOption && companyTypeOptions) {
      const filteredOptions = companyTypeOptions.filter((option) => option.toLowerCase() !== "admin");
      setFilteredOptions(filteredOptions);
    } else {
      setFilteredOptions(companyTypeOptions || []);
    }
  }, [showAdminOption, companyTypeOptions]);

  const options = transformDataToSelectOption(filteredOptions || [], "", "", t, "enumerables:companyTypes");

  return <Select data={options} loading={isLoading} {...restProps} />;
};

export default SelectCompanyType;
